import React from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { Theme } from '../varnish/Theme'; // eslint-disable-next-line import/prefer-default-export

export var ThemeProvider = function ThemeProvider(props) {
  var vTheme = props.theme || Theme["default"];
  return /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: vTheme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, props.children));
};